import type GetFileSizeType from './types';

const getFileSize: GetFileSizeType = () => {
    return Promise.resolve(0);
};

export default getFileSize;
